/* eslint-disable camelcase */
//! Blog Post - Graphic Control Measures
// *********************************************************************************** //
// * Import Styles and Material Design Component Modules                             * //
// *********************************************************************************** //
import 'normalize.css';
import '../src/styles/index.scss';
import { MDCTopAppBar } from '@material/top-app-bar';
import { MDCRipple } from '@material/ripple';
import { MDCList } from '@material/list';
import { MDCDialog } from '@material/dialog';
import { MDCMenuSurface } from '@material/menu-surface';
import { MDCIconButtonToggle } from '@material/icon-button';
// import { scrollTo, scrollIntoView } from 'scroll-js';
import MilSym from '../page-symbol-fundamentals/milsym';
import cardObj from './cardArray3';

// window.scrollTo = scrollTo;
// window.scrollIntoView = scrollIntoView;

const isProduction = process.env.NODE_ENV === 'production';
const serverUrl = isProduction ? '' : 'http://localhost:3000';
const signInPageUrl = `${serverUrl}/auth/sign-in`;

const freeAppUrl = isProduction ? '/app' : 'http://localhost:3000/app';

function getCookie(cname) {
  const name = `${cname}=`;
  const decodedCookie = decodeURIComponent(document.cookie);
  const ca = decodedCookie.split(';');
  for (let i = 0; i < ca.length; i += 1) {
    let c = ca[i];
    while (c.charAt(0) === ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length);
    }
  }
  return '';
}

// *********************************************************************************** //
// * Initialize All Buttons as Material Design Components                            * //
// *********************************************************************************** //
const buttons = document.querySelectorAll('.mdc-button');
buttons.forEach((btn) => {
  // Iterate through all buttons and attach to MDCRipple class
  const rippleButton = new MDCRipple(btn);
  rippleButton.listen('click', (event) => {
    if (event.target.classList.contains('sm')) {
      // Opens the social media icons in a new tab
      window.open(event.target.offsetParent.dataset.href, '_blank');
    }
    // MGRS Mapper sales pitch - Get user to login to view the pricing grid
    if (event.target.classList.contains('linkToPricingGrid')) {
      window.location = signInPageUrl;
    }
    // MGRS Mapper sales pitch - Try for Free
    if (event.target.classList.contains('tff')) {
      window.location = freeAppUrl;
    }
  });
});

// *********************************************************************************** //
// * Floating Action Button - Scroll to Top                                          * //
// *********************************************************************************** //
const fabRipple = new MDCRipple(document.querySelector('.mdc-fab'));

fabRipple.listen('click', () => {
  window.scrollTo({ top: 0, behavior: 'smooth' });
  // Sometimes when clicking on the scroll-to-top button when the user is near the footer, the scrollTo method does not go completely to the top of the page.
  // This is most likely due to the intersection observer firing off on symbol cards that are not yet generated
  setTimeout(() => {
    if (window.scrollY > 0) {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  }, 1000);
});

const callback = function (entries, observer) {
  entries.forEach((entry) => {
    if (entry.isIntersecting) {
      // The headline is visible to the user
      fabRipple.root_.classList.add('backOutRight');
    } else {
      // The user can no longer see the headline
      fabRipple.root_.classList.remove('backOutRight');
    }
  });
};

const observer = new IntersectionObserver(callback);
const target = document.querySelector('.headlineBackground');
observer.observe(target);

// *********************************************************************************** //
// * Top App Bar                                                                     * //
// *********************************************************************************** //
// Get the height of the Top App Bar component and set the padding-top for <main></main>
const topAppBar = new MDCTopAppBar(document.querySelector('.mdc-top-app-bar'));
const topAppBarHeight = topAppBar.root_.getBoundingClientRect().height;
const main = document.querySelector('#main');
main.style.paddingTop = `${topAppBarHeight}px`;

// Hamburger Menu
const menuSurface = new MDCMenuSurface(document.querySelector('.toolbar > .mdc-menu-surface'));
const iconToggle = new MDCIconButtonToggle(document.querySelector('.mdc-icon-button.headerMenuButton'));
iconToggle.listen('click', () => {
  if (iconToggle.on) {
    menuSurface.open(true);
  } else {
    menuSurface.close();
  }
});

menuSurface.listen('MDCMenuSurface:closed', () => {
  iconToggle.on = false;
});

// Hamburger Menu list items
const list = new MDCList(document.querySelector('#menuSurfaceList'));
list.singleSelection = true;
// eslint-disable-next-line array-callback-return
list.listElements.map((listItemEl) => {
  const li = new MDCRipple(listItemEl);
  // If the user is signed in then change the text content from "Try Free App" to "Use MGRS Mapper" on page load
  if (li.root_.id === 'tryFreeAppButtonOnSurfaceMenu' && getCookie('mgrs-mapper-signed-in')) {
    li.root_.innerHTML = `
      <svg height="24px" width="24px" preserveAspectRatio="xMidYMid" viewBox="21 46 158 108" xmlns="http://www.w3.org/2000/svg">
        <path stroke="#000" stroke-width="4" d="M25 50h150v100H25z" fill="#80E0FF" />
        <path d="M25 150L175 50" fill="none" stroke="#000" stroke-width="4" />
      </svg>
      <span class="mdc-list-item__text">
        Use MGRS Mapper
      </span>`;
  }
  // If the user is signed in then hide the login button
  if (li.root_.id === 'loginButtonOnSurfaceMenu' && getCookie('mgrs-mapper-signed-in')) {
    li.root_.style.display = 'none';
  }
  // If the user is signed in then hide the Join Premium list item
  if (li.root_.id === 'joinPremium' && getCookie('mgrs-mapper-signed-in')) {
    li.root_.style.display = 'none';
  }

  li.listen('click', () => {
    if (li.root_.id === 'returnHome') {
      window.location = isProduction ? '/' : 'http://localhost:3030';
      return;
    }
    if (li.root_.id === 'blogIndex') {
      window.location = isProduction ? '/blog' : 'http://localhost:3040/blog';
      return;
    }
    // Log the user in if he clicks on the login button on the surface menu for the Top App Bar
    if (li.root_.id === 'loginButtonOnSurfaceMenu') {
      console.log('Login into the application from Hamburger Surface Menu');
      if (isProduction) {
        // GA Event: Login button on Surface Menu
        window.gtag('event', 'login', {
          event_category: 'sales_page_login',
          event_label: 'surface_menu',
        });
      }
      window.location = signInPageUrl;
      return;
    }
    if (li.root_.id === 'tryFreeAppButtonOnSurfaceMenu') {
      console.log('Try free app from Surface Menu');
      if (isProduction) {
        // GA Event: Try free app from Surface Menu
        window.gtag('event', 'view_item', {
          event_category: 'sales_page_free_app',
          event_label: 'surface_menu',
        });
      }
      window.location = freeAppUrl;
      return;
    }
    if (li.root_.id === 'joinPremium') {
      window.location = signInPageUrl;
    }
  });
});

// *********************************************************************************** //
// * Table of Contents and Loading Dialog                                            * //
// *********************************************************************************** //
const dialog = new MDCDialog(document.querySelector('.mdc-dialog'));

// Setup isScrolling variable
let isScrolling;

document.querySelectorAll('.toc-list').forEach((l) => {
  const tocListElement = new MDCList(l);
  tocListElement.listElements.map((listItemEl) => {
    const tocListItem = new MDCRipple(listItemEl);
    tocListItem.listen('click', () => {
      const scrollTarget = document.querySelector(`#${tocListItem.root_.dataset.scrollto}`);
      window.scrollTo({ top: scrollTarget.offsetTop - 40, behavior: 'smooth' });
      // Listen for scroll events
      // https://gomakethings.com/detecting-when-a-visitor-has-stopped-scrolling-with-vanilla-javascript/
      window.addEventListener('scroll', function garbage(event) {
        // Don't open the dialog if the section is 9500 units away from the top of the page
        if (window.pageYOffset >= 9500) {
          dialog.open();
        }
        // Clear our timeout throughout the scroll
        window.clearTimeout(isScrolling);
        // Set a timeout to run after scrolling ends
        isScrolling = setTimeout(() => {
          if (window.pageYOffset <= scrollTarget.offsetTop - 40) {
            // Negate 30 units so the user can see the H3 tag
            window.scrollTo({ top: scrollTarget.offsetTop - 30, behavior: 'smooth' });
            event.stopImmediatePropagation();
          } else {
            // important: remove the event listener
            window.removeEventListener('scroll', garbage);
            dialog.close();
          }
        }, 400);
      });
    });
  });
});

dialog.listen('MDCDialog:opened', () => {
  // Automatically close the Dialog if its open for more than 3.5 seconds
  setTimeout(() => {
    if (dialog.foundation_.isOpen()) {
      console.log('closing');
      dialog.close();
    }
  }, 3500);
});

document.querySelectorAll('.blogArticleList').forEach((l) => {
  const tocListElement = new MDCList(l);
  tocListElement.listElements.forEach((listItemEl) => {
    const tocListItem = new MDCRipple(listItemEl);
    tocListItem.listen('click', (event) => {
      const elements = document.elementsFromPoint(event.clientX, event.clientY);
      const chosenTarget = elements.find((key) => key.matches('li'));
      document.location.href = chosenTarget.querySelector('a').getAttribute('href');
    });
  });
});

// *********************************************************************************** //
// * Watch Tour - iFrame Video                                                       * //
// *********************************************************************************** //
const dialogContainer = new MDCDialog(document.querySelector('.dialog-video-container'));
const dialogTitle = dialogContainer.container_.querySelector('#feature-dialog-title');
const dialogExtraInfo = dialogContainer.container_.querySelector('#feature-dialog-extra-info');
const dialogVideo = dialogContainer.container_.querySelector('.dialogVideo');
const watchTourButton = new MDCRipple(document.querySelector('.watchTourButton'));
watchTourButton.listen('click', () => {
  dialogTitle.innerText = 'MGRS Mapper Premium Features';
  dialogExtraInfo.innerText = 'When you upgrade to a Premium account you get access to tons of new features not available in the free version';
  // Set the <video> tag display to none so we can inject an iframe
  dialogVideo.style.display = 'none';
  // Check to see if there is an existing iframe in the dialog container
  // This is useful when a user clicks in and out of the Tour Video, so there won't be multiple iframes
  dialogContainer.content_.childNodes.forEach((node) => {
    if (node.tagName === 'IFRAME') {
      node.remove();
    }
  });
  // Get width of video based on screen width
  const width = document.documentElement.clientWidth < 415 ? 340 : 720;
  const height = document.documentElement.clientWidth < 415 ? width / 1.778 : 405;
  dialogExtraInfo.insertAdjacentHTML('afterend', `<iframe width="${width}px" height="${height}px" src="https://www.youtube.com/embed/UwTo7y_gGNg?autoplay=1" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>`);
  if (isProduction) {
    // GA Event: User watches the tour video on the Hero Section
    window.gtag('event', 'view_item', {
      event_category: 'sales_page_watch_tour_video',
    });
  }
  dialogContainer.open();
});

// If the dialog window is closed, check if the dialog contains an iframe video
// If it does then remove it, otherwise the audio will play in the background
dialogContainer.listen('MDCDialog:closed', () => {
  dialogContainer.content_.childNodes.forEach((node) => {
    if (node.tagName === 'IFRAME') {
      node.remove();
    }
  });
});

// *********************************************************************************** //
// * Generate Symbols                                                                * //
// *********************************************************************************** //
async function generateMilitarySymbolCard(location, symbol, affiliation = 'friendly', echelon = undefined, mod1 = undefined, mod2 = undefined, headline = undefined, uniqueDesignation = undefined, higherFormation = undefined, reinforcedReduced = undefined, flying = undefined, activity = undefined, installation = undefined, taskForce = undefined, commandPost = undefined) {
  // const randomInt = Math.floor(Math.random() * Math.floor(Object.keys(militarySymbolsObject).length));
  // const randomSymbol = Object.keys(militarySymbolsObject)[randomInt];

  const cardParent = document.createElement('div');
  cardParent.classList.add('mdc-card', 'mdc-card--outlined');

  // Card - Primary Action
  const cardPrimaryAction = document.createElement('div');
  cardPrimaryAction.classList.add('mdc-card__primary-action');
  cardParent.appendChild(cardPrimaryAction);

  const cardPrimaryActionTitleParent = document.createElement('div');
  cardPrimaryActionTitleParent.classList.add('mdc-card__media', 'mdc-card__media--16-9');
  cardPrimaryAction.appendChild(cardPrimaryActionTitleParent);

  const cardPrimaryActionTitleChild = document.createElement('div');
  cardPrimaryActionTitleChild.classList.add('mdc-card__media-content', 'mdc-typography--headline5', 'cardTitle');
  cardPrimaryActionTitleChild.innerText = headline !== undefined ? headline : symbol;
  cardPrimaryActionTitleParent.appendChild(cardPrimaryActionTitleChild);

  const cardPrimaryActionSymbolParent = document.createElement('div');
  cardPrimaryActionSymbolParent.classList.add('mdc-card__media', 'mdc-card__media--square');
  cardPrimaryAction.appendChild(cardPrimaryActionSymbolParent);

  const cardPrimaryActionSymbolChild = document.createElement('div');
  const randomSymbolClass = `milsym_${Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15)}`;
  cardPrimaryActionSymbolChild.classList.add('mdc-card__media-content', 'symbolDiv', randomSymbolClass);
  cardPrimaryActionSymbolParent.appendChild(cardPrimaryActionSymbolChild);

  // Card - Actions
  const cardActions = document.createElement('div');
  cardActions.classList.add('mdc-card__actions');
  cardParent.appendChild(cardActions);

  const cardActionsButtonsParent = document.createElement('div');
  cardActionsButtonsParent.classList.add('mdc-card__action-buttons');
  cardActions.appendChild(cardActionsButtonsParent);

  const cardActionsButtonAffiliation = document.createElement('button');
  const randomAffiliationClass = `affiliation_${Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15)}`;
  cardActionsButtonAffiliation.classList.add('mdc-button', 'mdc-menu-surface--anchor', 'mdc-card__action', 'mdc-card__action--button', 'changeAffiliationButton', randomAffiliationClass);
  cardActionsButtonsParent.appendChild(cardActionsButtonAffiliation);

  const cardActionsButtonAffiliationRipple = document.createElement('div');
  cardActionsButtonAffiliationRipple.classList.add('mdc-button__ripple');
  cardActionsButtonAffiliation.appendChild(cardActionsButtonAffiliationRipple);

  const cardActionsButtonAffiliationSpan = document.createElement('span');
  cardActionsButtonAffiliationSpan.classList.add('mdc-button__label');
  cardActionsButtonAffiliationSpan.innerText = 'Affiliation';
  cardActionsButtonAffiliation.appendChild(cardActionsButtonAffiliationSpan);

  const cardActionsButtonAffiliationMenu = document.createElement('div');
  const randomAffiliationMenuClass = `menu_${Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15)}`;
  cardActionsButtonAffiliationMenu.classList.add('mdc-menu', 'mdc-menu-surface', 'changeAffiliationMenu', randomAffiliationMenuClass);
  cardActionsButtonAffiliation.appendChild(cardActionsButtonAffiliationMenu);

  const cardActionsButtonAffiliationMenuList = document.createElement('ul');
  const randomAffiliationListClass = `list_${Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15)}`;
  cardActionsButtonAffiliationMenuList.classList.add('mdc-list', 'changeAffiliationList', randomAffiliationListClass);
  cardActionsButtonAffiliationMenuList.setAttribute('role', 'menu');
  cardActionsButtonAffiliationMenuList.setAttribute('aria-hidden', 'true');
  cardActionsButtonAffiliationMenuList.setAttribute('orientation', 'vertical');
  cardActionsButtonAffiliationMenu.appendChild(cardActionsButtonAffiliationMenuList);

  // Surface Menu - Friendly
  const friendlyLi = document.createElement('li');
  friendlyLi.classList.add('mdc-list-item');
  friendlyLi.setAttribute('role', 'menuitem');
  friendlyLi.setAttribute('tabindex', '0');
  const friendlySVG = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
  friendlySVG.setAttributeNS(null, 'height', '48px');
  friendlySVG.setAttributeNS(null, 'width', '48px');
  friendlySVG.setAttributeNS(null, 'preserveAspectRatio', 'xMidYMid');
  friendlySVG.setAttributeNS(null, 'viewBox', '21 46 158 108');
  const friendlyOutline = document.createElementNS('http://www.w3.org/2000/svg', 'path');
  friendlyOutline.setAttributeNS(null, 'd', 'M25 50h150v100H25z');
  friendlyOutline.setAttributeNS(null, 'stroke', '#000');
  friendlyOutline.setAttributeNS(null, 'stroke-width', '8');
  friendlyOutline.setAttributeNS(null, 'fill', 'rgb(128,224,255)');
  friendlySVG.appendChild(friendlyOutline);
  const friendlyLi_span = document.createElement('span');
  friendlyLi_span.classList.add('mdc-list-item__text');
  friendlyLi_span.innerText = 'Friendly';
  friendlyLi.appendChild(friendlyLi_span);
  friendlyLi.appendChild(friendlySVG);
  cardActionsButtonAffiliationMenuList.appendChild(friendlyLi);

  // Surface Menu - Friendly Templated
  const friendlyTemplatedLi = document.createElement('li');
  friendlyTemplatedLi.classList.add('mdc-list-item');
  friendlyTemplatedLi.setAttribute('role', 'menuitem');
  friendlyTemplatedLi.setAttribute('tabindex', '-1');
  const friendlyTemplatedSVG = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
  friendlyTemplatedSVG.setAttributeNS(null, 'height', '48px');
  friendlyTemplatedSVG.setAttributeNS(null, 'width', '48px');
  friendlyTemplatedSVG.setAttributeNS(null, 'preserveAspectRatio', 'xMidYMid');
  friendlyTemplatedSVG.setAttributeNS(null, 'viewBox', '21 46 158 108');
  const friendlyTemplatedOutline = document.createElementNS('http://www.w3.org/2000/svg', 'path');
  friendlyTemplatedOutline.setAttributeNS(null, 'd', 'M25 50h150v100H25z');
  friendlyTemplatedOutline.setAttributeNS(null, 'stroke', '#000');
  friendlyTemplatedOutline.setAttributeNS(null, 'stroke-width', '8');
  friendlyTemplatedOutline.setAttributeNS(null, 'stroke-dasharray', '7,7');
  friendlyTemplatedOutline.setAttributeNS(null, 'fill', 'rgb(128,224,255)');
  friendlyTemplatedSVG.appendChild(friendlyTemplatedOutline);
  const friendlyTemplatedLi_span = document.createElement('span');
  friendlyTemplatedLi_span.classList.add('mdc-list-item__text');
  friendlyTemplatedLi_span.innerText = 'Assumed Friendly';
  friendlyTemplatedLi.appendChild(friendlyTemplatedLi_span);
  friendlyTemplatedLi.appendChild(friendlyTemplatedSVG);
  cardActionsButtonAffiliationMenuList.appendChild(friendlyTemplatedLi);

  // Surface Menu - Hostile
  const hostileLi = document.createElement('li');
  hostileLi.classList.add('mdc-list-item');
  hostileLi.setAttribute('role', 'menuitem');
  hostileLi.setAttribute('tabindex', '-1');
  const hostileSVG = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
  hostileSVG.setAttributeNS(null, 'height', '48px');
  hostileSVG.setAttributeNS(null, 'width', '48px');
  hostileSVG.setAttributeNS(null, 'preserveAspectRatio', 'xMidYMid');
  hostileSVG.setAttributeNS(null, 'viewBox', '21 46 158 108');
  const hostileOutline = document.createElementNS('http://www.w3.org/2000/svg', 'path');
  hostileOutline.setAttributeNS(null, 'd', 'M 100,28 L172,100 100,172 28,100 100,28 Z');
  hostileOutline.setAttributeNS(null, 'stroke', '#000');
  hostileOutline.setAttributeNS(null, 'stroke-width', '8');
  hostileOutline.setAttributeNS(null, 'fill', 'rgb(255,128,128)');
  hostileSVG.appendChild(hostileOutline);
  const hostileLi_span = document.createElement('span');
  hostileLi_span.classList.add('mdc-list-item__text');
  hostileLi_span.innerText = 'Hostile';
  hostileLi.appendChild(hostileLi_span);
  hostileLi.appendChild(hostileSVG);
  cardActionsButtonAffiliationMenuList.appendChild(hostileLi);

  // Surface Menu - Hostile Templated
  const hostileTemplatedLi = document.createElement('li');
  hostileTemplatedLi.classList.add('mdc-list-item');
  hostileTemplatedLi.setAttribute('role', 'menuitem');
  hostileTemplatedLi.setAttribute('tabindex', '-1');
  const hostileTemplatedSVG = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
  hostileTemplatedSVG.setAttributeNS(null, 'height', '48px');
  hostileTemplatedSVG.setAttributeNS(null, 'width', '48px');
  hostileTemplatedSVG.setAttributeNS(null, 'preserveAspectRatio', 'xMidYMid');
  hostileTemplatedSVG.setAttributeNS(null, 'viewBox', '21 46 158 108');
  const hostileTemplatedOutline = document.createElementNS('http://www.w3.org/2000/svg', 'path');
  hostileTemplatedOutline.setAttributeNS(null, 'd', 'M 100,28 L172,100 100,172 28,100 100,28 Z');
  hostileTemplatedOutline.setAttributeNS(null, 'stroke', '#000');
  hostileTemplatedOutline.setAttributeNS(null, 'stroke-width', '8');
  hostileTemplatedOutline.setAttributeNS(null, 'stroke-dasharray', '7,7');
  hostileTemplatedOutline.setAttributeNS(null, 'fill', 'rgb(255,128,128)');
  hostileTemplatedSVG.appendChild(hostileTemplatedOutline);
  const hostileTemplatedLi_span = document.createElement('span');
  hostileTemplatedLi_span.classList.add('mdc-list-item__text');
  hostileTemplatedLi_span.innerText = 'Assumed Hostile';
  hostileTemplatedLi.appendChild(hostileTemplatedLi_span);
  hostileTemplatedLi.appendChild(hostileTemplatedSVG);
  cardActionsButtonAffiliationMenuList.appendChild(hostileTemplatedLi);

  // Surface Menu - Unknown
  const unknownLi = document.createElement('li');
  unknownLi.classList.add('mdc-list-item');
  unknownLi.setAttribute('role', 'menuitem');
  unknownLi.setAttribute('tabindex', '-1');
  const unknownSVG = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
  unknownSVG.setAttributeNS(null, 'height', '48px');
  unknownSVG.setAttributeNS(null, 'width', '48px');
  unknownSVG.setAttributeNS(null, 'preserveAspectRatio', 'xMidYMid');
  unknownSVG.setAttributeNS(null, 'viewBox', '21 46 158 108');
  const unknownOutline = document.createElementNS('http://www.w3.org/2000/svg', 'path');
  unknownOutline.setAttributeNS(null, 'd', 'M63,63 C63,20 137,20 137,63 C180,63 180,137 137,137 C137,180 63,180 63,137 C20,137 20,63 63,63 Z');
  unknownOutline.setAttributeNS(null, 'stroke', '#000');
  unknownOutline.setAttributeNS(null, 'stroke-width', '8');
  unknownOutline.setAttributeNS(null, 'fill', 'rgb(255,255,128)');
  unknownSVG.appendChild(unknownOutline);
  const unknownLi_span = document.createElement('span');
  unknownLi_span.classList.add('mdc-list-item__text');
  unknownLi_span.innerText = 'Unknown';
  unknownLi.appendChild(unknownLi_span);
  unknownLi.appendChild(unknownSVG);
  cardActionsButtonAffiliationMenuList.appendChild(unknownLi);

  // Surface Menu - Pending
  const pendingLi = document.createElement('li');
  pendingLi.classList.add('mdc-list-item');
  pendingLi.setAttribute('role', 'menuitem');
  pendingLi.setAttribute('tabindex', '-1');
  const pendingSVG = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
  pendingSVG.setAttributeNS(null, 'height', '48px');
  pendingSVG.setAttributeNS(null, 'width', '48px');
  pendingSVG.setAttributeNS(null, 'preserveAspectRatio', 'xMidYMid');
  pendingSVG.setAttributeNS(null, 'viewBox', '21 46 158 108');
  const pendingOutline = document.createElementNS('http://www.w3.org/2000/svg', 'path');
  pendingOutline.setAttributeNS(null, 'd', 'M63,63 C63,20 137,20 137,63 C180,63 180,137 137,137 C137,180 63,180 63,137 C20,137 20,63 63,63 Z');
  pendingOutline.setAttributeNS(null, 'stroke', '#000');
  pendingOutline.setAttributeNS(null, 'stroke-width', '8');
  pendingOutline.setAttributeNS(null, 'stroke-dasharray', '7,7');
  pendingOutline.setAttributeNS(null, 'fill', 'rgb(255,255,128)');
  pendingSVG.appendChild(pendingOutline);
  const pendingLi_span = document.createElement('span');
  pendingLi_span.classList.add('mdc-list-item__text');
  pendingLi_span.innerText = 'Pending';
  pendingLi.appendChild(pendingLi_span);
  pendingLi.appendChild(pendingSVG);
  cardActionsButtonAffiliationMenuList.appendChild(pendingLi);

  // Surface Menu - Neutral
  const neutralLi = document.createElement('li');
  neutralLi.classList.add('mdc-list-item');
  neutralLi.setAttribute('role', 'menuitem');
  neutralLi.setAttribute('tabindex', '-1');
  const neutralSVG = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
  neutralSVG.setAttributeNS(null, 'height', '48px');
  neutralSVG.setAttributeNS(null, 'width', '48px');
  neutralSVG.setAttributeNS(null, 'preserveAspectRatio', 'xMidYMid');
  neutralSVG.setAttributeNS(null, 'viewBox', '21 46 158 108');
  const neutralOutline = document.createElementNS('http://www.w3.org/2000/svg', 'path');
  neutralOutline.setAttributeNS(null, 'd', 'M45,45 l110,0 0,110 -110,0 z');
  neutralOutline.setAttributeNS(null, 'stroke', '#000');
  neutralOutline.setAttributeNS(null, 'stroke-width', '8');
  neutralOutline.setAttributeNS(null, 'fill', 'rgb(170, 255, 170)');
  neutralSVG.appendChild(neutralOutline);
  const neutralLi_span = document.createElement('span');
  neutralLi_span.classList.add('mdc-list-item__text');
  neutralLi_span.innerText = 'Neutral';
  neutralLi.appendChild(neutralLi_span);
  neutralLi.appendChild(neutralSVG);
  cardActionsButtonAffiliationMenuList.appendChild(neutralLi);

  const downloadButton = document.createElement('button');
  downloadButton.classList.add('mdc-button', 'mdc-card__action', 'mdc-card__action--button', 'downloadSymbol');
  cardActionsButtonsParent.appendChild(downloadButton);

  const downloadButtonRipple = document.createElement('div');
  downloadButtonRipple.classList.add('mdc-button__ripple');
  downloadButton.appendChild(downloadButtonRipple);

  const downloadButtonSpan = document.createElement('span');
  downloadButtonSpan.classList.add('mdc-button__label');
  downloadButtonSpan.innerText = 'Download';
  downloadButton.appendChild(downloadButtonSpan);

  // const iconContainer = document.createElement('div');
  // iconContainer.classList.add('mdc-card__action-icons');
  // cardActions.appendChild(iconContainer);

  // const iconShare = document.createElement('button');
  // iconShare.classList.add('material-icons', 'mdc-icon-button', 'mdc-card__action', 'mdc-card__action--icon');
  // iconShare.setAttribute('title', 'Share');
  // iconShare.innerText = 'share';
  // iconContainer.appendChild(iconShare);

  // const iconVert = document.createElement('button');
  // iconVert.classList.add('material-icons', 'mdc-icon-button', 'mdc-card__action', 'mdc-card__action--icon');
  // iconVert.setAttribute('title', 'More Options');
  // iconVert.innerText = 'more_vert';
  // iconContainer.appendChild(iconVert);

  await document.querySelector(location).appendChild(cardParent);

  // Now add the Military Symbol
  const randSym = new MilSym(`.${randomSymbolClass}`, symbol, affiliation, echelon, mod1, mod2, uniqueDesignation, higherFormation, reinforcedReduced, flying, activity, installation, taskForce, commandPost);
  // The location of the Military Symbol within the card
  const randSymbolToChange = document.querySelector(randSym._location);
  // Affiliation Button on the MDC Card
  const affBtn = new MDCRipple(document.querySelector(`.changeAffiliationButton.${randomAffiliationClass}`));
  // Affiliation MDC Surface Menu
  const affMenu = new MDCMenuSurface(document.querySelector(`.changeAffiliationMenu.${randomAffiliationMenuClass}`));

  // Download the symbol as an SVG
  downloadButton.addEventListener('click', () => {
    const symbolToDownload = randSymbolToChange.querySelector('svg');
    // Animate the symbol out then in
    randSymbolToChange.classList.add('scaleOutThenScaleIn');
    // Grab the original width, height, and viewBox settings from the downloaded SVG
    const originalViewBox = symbolToDownload.getAttribute('viewBox');
    const originalWidth = symbolToDownload.getAttribute('width');
    const originalHeight = symbolToDownload.getAttribute('height');
    symbolToDownload.setAttributeNS(null, 'preserveAspectRatio', 'xMidYMid');
    // Blow the image up by 3x
    symbolToDownload.setAttributeNS(null, 'width', `${symbolToDownload.getAttribute('width') * 3}`);
    symbolToDownload.setAttributeNS(null, 'height', `${symbolToDownload.getAttribute('height') * 3}`);
    // Add the new viewBox string, this is necessary IOT get the SVG file to center properly
    symbolToDownload.setAttributeNS(null, 'viewBox', `${symbolToDownload.getBBox().x - 4} ${symbolToDownload.getBBox().y - 4} ${symbolToDownload.getBBox().width + 8} ${symbolToDownload.getBBox().height + 8}`);
    // Remove spaces in symbol name
    const symbolName = JSON.parse(symbolToDownload.dataset.symbolInfo).Symbol.replace(/\s/g, '-');
    symbolToDownload.setAttribute('xmlns', 'http://www.w3.org/2000/svg');
    const svgData = symbolToDownload.outerHTML;
    const preface = '<?xml version="1.0" standalone="no"?>\r\n';
    const svgBlob = new Blob([preface, svgData], { type: 'image/svg+xml;charset=utf-8' });
    const svgUrl = URL.createObjectURL(svgBlob);
    const downloadLink = document.createElement('a');
    downloadLink.href = svgUrl;
    downloadLink.download = `${symbolName}_MGRS-Mapper.svg`;
    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);
    // Now since the file is done downloading, reapply the original width, height and viewBox
    symbolToDownload.setAttributeNS(null, 'viewBox', `${originalViewBox}`);
    symbolToDownload.setAttributeNS(null, 'width', originalWidth);
    symbolToDownload.setAttributeNS(null, 'height', originalHeight);
    randSymbolToChange.addEventListener('animationend', () => {
      // when the animation has ended, remove the class
      randSymbolToChange.classList.remove('scaleOutThenScaleIn');
    }, { once: true });
  });

  const parent = cardParent.parentElement.querySelector('.symbolExcerpt');

  function formattedAffiliation(aff) {
    switch (aff) {
      case 'friendly':
        return 'Friendly';
      case 'friendlyTemplated':
        return 'Assumed Friendly';
      case 'hostile':
        return 'Hostile';
      case 'hostileTemplated':
        return 'Assumed Hostile';
      case 'unknown':
        return 'Unknown';
      case 'pending':
        return 'Pending';
      case 'neutral':
        return 'Neutral';
      default:
        break;
    }
    return aff;
  }

  // Just checks if there is a div class called .symbolExcerpt and appends it to the MDC Card
  if (parent) {
    const symbolInfo = document.createElement('div');
    symbolInfo.classList.add('mdc-card__media', 'mdc-card__media--16-9');
    // Since there is already some HTML data in parent, we clone it so we can put it into the symbolInfo div
    const symbolInfoClone = parent.cloneNode(true);
    // Now that parent has been cloned, delete it
    parent.remove();
    symbolInfo.appendChild(symbolInfoClone);
    cardPrimaryAction.appendChild(symbolInfo);
    // Dynamically sets the affiliation, mod1 and mod2 data in the card
    if (symbolInfoClone.querySelector('.symbol--affiliation')) {
      symbolInfoClone.querySelector('.symbol--name').innerHTML = `<strong>Base Symbol: </strong> ${symbol}`;
      symbolInfoClone.querySelector('.symbol--affiliation').innerHTML = `<strong>Affiliation: </strong> ${formattedAffiliation(affiliation)}`;
      if (mod1) {
        symbolInfoClone.querySelector('.symbol--mod1').innerHTML = `<strong>Sector 1 Modifier: </strong> ${mod1}`;
      }
      if (mod2) {
        symbolInfoClone.querySelector('.symbol--mod2').innerHTML = `<strong>Sector 2 Modifier: </strong> ${mod2}`;
      }
    }
  }

  // If the symbol is a TMT, then disable the affiliation button and return
  if (randSym.type === 'Tactical Mission Task') {
    affBtn.root_.disabled = true;
    affBtn.root_.style.display = 'none';
    cardActions.style.backgroundColor = 'whitesmoke';
    return;
  }

  // If the symbol is a GCM, then disable the affiliation button and return
  if (randSym.type === 'Graphic Control Measure') {
    affBtn.root_.disabled = true;
    affBtn.root_.style.display = 'none';
    cardActions.style.backgroundColor = 'whitesmoke';
    return;
  }

  // Ensure the affiliation button is not disabled
  affBtn.root_.disabled = false;
  affBtn.listen('click', () => {
    affMenu.open();
  });

  // Affiliation List on the Surface Menu
  const affLi = new MDCList(document.querySelector(`.mdc-list.changeAffiliationList.${randomAffiliationListClass}`));

  // Sets the Surface Menu's index to the first element, which will be "friendly"
  affLi.foundation_.setSelectedIndex(0);

  function affiliationSwitcher(aff) {
    switch (aff) {
      case 'friendly':
        randSym.affiliation = 'friendly';
        affLi.foundation_.setSelectedIndex(0);
        randSym.placeSymbol();
        cardActions.style.backgroundColor = 'rgb(128,224,255)';
        downloadButton.style.color = 'midnightblue';
        cardActionsButtonAffiliation.style.color = 'midnightblue';
        cardParent.querySelector('.symbol--affiliation').innerHTML = '<strong>Affiliation: </strong> Friendly';
        break;
      case 'friendlyTemplated':
        randSym.affiliation = 'friendlyTemplated';
        affLi.foundation_.setSelectedIndex(1);
        randSym.placeSymbol();
        cardActions.style.backgroundColor = 'rgb(128,224,255)';
        downloadButton.style.color = 'midnightblue';
        cardActionsButtonAffiliation.style.color = 'midnightblue';
        cardParent.querySelector('.symbol--affiliation').innerHTML = '<strong>Affiliation: </strong> Assumed Friendly';
        break;
      case 'hostile':
        randSym.affiliation = 'hostile';
        affLi.foundation_.setSelectedIndex(2);
        randSym.placeSymbol();
        cardActions.style.backgroundColor = 'rgb(255,128,128)';
        downloadButton.style.color = 'white';
        cardActionsButtonAffiliation.style.color = 'white';
        cardParent.querySelector('.symbol--affiliation').innerHTML = '<strong>Affiliation: </strong> Hostile';
        break;
      case 'hostileTemplated':
        randSym.affiliation = 'hostileTemplated';
        affLi.foundation_.setSelectedIndex(3);
        randSym.placeSymbol();
        cardActions.style.backgroundColor = 'rgb(255,128,128)';
        downloadButton.style.color = 'white';
        cardActionsButtonAffiliation.style.color = 'white';
        cardParent.querySelector('.symbol--affiliation').innerHTML = '<strong>Affiliation: </strong> Assumed Hostile';
        break;
      case 'unknown':
        randSym.affiliation = 'unknown';
        affLi.foundation_.setSelectedIndex(4);
        randSym.placeSymbol();
        cardActions.style.backgroundColor = 'rgb(255,255,128)';
        downloadButton.style.color = 'midnightblue';
        cardActionsButtonAffiliation.style.color = 'midnightblue';
        cardParent.querySelector('.symbol--affiliation').innerHTML = '<strong>Affiliation: </strong> Unknown';
        break;
      case 'pending':
        randSym.affiliation = 'pending';
        affLi.foundation_.setSelectedIndex(5);
        randSym.placeSymbol();
        cardActions.style.backgroundColor = 'rgb(255,255,128)';
        downloadButton.style.color = 'midnightblue';
        cardActionsButtonAffiliation.style.color = 'midnightblue';
        cardParent.querySelector('.symbol--affiliation').innerHTML = '<strong>Affiliation: </strong> Pending';
        break;
      case 'neutral':
        randSym.affiliation = 'neutral';
        affLi.foundation_.setSelectedIndex(6);
        randSym.placeSymbol();
        cardActions.style.backgroundColor = 'rgb(170, 255, 170)';
        downloadButton.style.color = 'midnightblue';
        cardActionsButtonAffiliation.style.color = 'midnightblue';
        cardParent.querySelector('.symbol--affiliation').innerHTML = '<strong>Affiliation: </strong> Neutral';
        break;
      default:
        break;
    }
  }

  // Run the affiliation switcher function only if the initial symbol is NOT friendly
  if (affiliation !== 'friendly') {
    affiliationSwitcher(affiliation);
  }

  // Callback function that removes the animation class from the symbol after a user changes affiliation
  const transitionEndCallback = () => {
    randSymbolToChange.classList.remove('scaleOutThenScaleIn');
    randSymbolToChange.removeEventListener('animationend', transitionEndCallback);
  };

  affLi.listen('MDCList:action', (e) => {
    switch (e.detail.index) {
      case 0:
        // friendly
        randSymbolToChange.classList.toggle('scaleOutThenScaleIn');
        randSymbolToChange.addEventListener('animationend', transitionEndCallback);
        affiliationSwitcher('friendly');
        break;
      case 1:
        // friendlyTemplated
        randSymbolToChange.classList.toggle('scaleOutThenScaleIn');
        randSymbolToChange.addEventListener('animationend', transitionEndCallback);
        affiliationSwitcher('friendlyTemplated');
        break;
      case 2:
        // hostile
        randSymbolToChange.classList.toggle('scaleOutThenScaleIn');
        randSymbolToChange.addEventListener('animationend', transitionEndCallback);
        affiliationSwitcher('hostile');
        break;
      case 3:
        // hostileTemplated
        randSymbolToChange.classList.toggle('scaleOutThenScaleIn');
        randSymbolToChange.addEventListener('animationend', transitionEndCallback);
        affiliationSwitcher('hostileTemplated');
        break;
      case 4:
        // unknown
        randSymbolToChange.classList.toggle('scaleOutThenScaleIn');
        randSymbolToChange.addEventListener('animationend', transitionEndCallback);
        affiliationSwitcher('unknown');
        break;
      case 5:
        // pending
        randSymbolToChange.classList.toggle('scaleOutThenScaleIn');
        randSymbolToChange.addEventListener('animationend', transitionEndCallback);
        affiliationSwitcher('pending');
        break;
      case 6:
        // neutral
        randSymbolToChange.classList.toggle('scaleOutThenScaleIn');
        randSymbolToChange.addEventListener('animationend', transitionEndCallback);
        affiliationSwitcher('neutral');
        break;
      default:
        break;
    }
    // Dispatches an event notifying listeners that the menu surface has been closed.
    affMenu.foundation_.adapter_.notifyClose();
  });

  // Closes the card's Surface Menu when a user clicks on an affiliation
  affMenu.listen('MDCMenuSurface:closed', () => {
    affMenu.close();
  });
}

// *********************************************************************************** //
// * Intersection observer to load symbol cards                                      * //
// *********************************************************************************** //
if ('IntersectionObserver' in window) {
  const cardObserver = new IntersectionObserver(((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        switch (entry.target.dataset.section) {
          case 'gcm-icons':
            cardObj[entry.target.dataset.section].forEach((icon) => generateMilitarySymbolCard(...icon));
            cardObserver.unobserve(entry.target);
            document.querySelector(`[data-section="${entry.target.dataset.section}"]`).setAttribute('data-loaded', true);
            break;
          case 'gcm-icons-points':
            cardObj[entry.target.dataset.section].forEach((icon) => generateMilitarySymbolCard(...icon));
            cardObserver.unobserve(entry.target);
            document.querySelector(`[data-section="${entry.target.dataset.section}"]`).setAttribute('data-loaded', true);
            break;
          case 'gcm-icons-mam':
            cardObj[entry.target.dataset.section].forEach((icon) => generateMilitarySymbolCard(...icon));
            cardObserver.unobserve(entry.target);
            document.querySelector(`[data-section="${entry.target.dataset.section}"]`).setAttribute('data-loaded', true);
            break;
          case 'gcm-icons-op':
            cardObj[entry.target.dataset.section].forEach((icon) => generateMilitarySymbolCard(...icon));
            cardObserver.unobserve(entry.target);
            document.querySelector(`[data-section="${entry.target.dataset.section}"]`).setAttribute('data-loaded', true);
            break;
          case 'gcm-icons-air':
            cardObj[entry.target.dataset.section].forEach((icon) => generateMilitarySymbolCard(...icon));
            cardObserver.unobserve(entry.target);
            document.querySelector(`[data-section="${entry.target.dataset.section}"]`).setAttribute('data-loaded', true);
            break;
          case 'gcm-icons-maritime':
            cardObj[entry.target.dataset.section].forEach((icon) => generateMilitarySymbolCard(...icon));
            cardObserver.unobserve(entry.target);
            document.querySelector(`[data-section="${entry.target.dataset.section}"]`).setAttribute('data-loaded', true);
            break;
          case 'gcm-icons-tgt':
            cardObj[entry.target.dataset.section].forEach((icon) => generateMilitarySymbolCard(...icon));
            cardObserver.unobserve(entry.target);
            document.querySelector(`[data-section="${entry.target.dataset.section}"]`).setAttribute('data-loaded', true);
            break;
          case 'gcm-icons-mcm':
            cardObj[entry.target.dataset.section].forEach((icon) => generateMilitarySymbolCard(...icon));
            cardObserver.unobserve(entry.target);
            document.querySelector(`[data-section="${entry.target.dataset.section}"]`).setAttribute('data-loaded', true);
            break;
          case 'gcm-icons-mines':
            cardObj[entry.target.dataset.section].forEach((icon) => generateMilitarySymbolCard(...icon));
            cardObserver.unobserve(entry.target);
            document.querySelector(`[data-section="${entry.target.dataset.section}"]`).setAttribute('data-loaded', true);
            break;
          case 'gcm-icons-fortifications':
            cardObj[entry.target.dataset.section].forEach((icon) => generateMilitarySymbolCard(...icon));
            cardObserver.unobserve(entry.target);
            document.querySelector(`[data-section="${entry.target.dataset.section}"]`).setAttribute('data-loaded', true);
            break;
          case 'gcm-icons-cbrn':
            cardObj[entry.target.dataset.section].forEach((icon) => generateMilitarySymbolCard(...icon));
            cardObserver.unobserve(entry.target);
            document.querySelector(`[data-section="${entry.target.dataset.section}"]`).setAttribute('data-loaded', true);
            break;
          case 'gcm-icons-route':
            cardObj[entry.target.dataset.section].forEach((icon) => generateMilitarySymbolCard(...icon));
            cardObserver.unobserve(entry.target);
            document.querySelector(`[data-section="${entry.target.dataset.section}"]`).setAttribute('data-loaded', true);
            break;
          default:
            break;
        }
      }
    });
  }), {
    root: null,
    rootMargin: '50%',
    threshold: 0,
  });

  const targets = [Array.from(document.querySelectorAll('.cardGrid'))].flat();
  targets.forEach((tgt) => cardObserver.observe(tgt));
} else {
  // If Intersection Observer isn't present, then just run everything at once.
  console.error('IntersectionObserver is not compatible with this browser');
  Object.values(cardObj).forEach((c) => {
    for (let index = 0; index < c.length; index += 1) {
      const card = c[index];
      generateMilitarySymbolCard(...card);
    }
    document.querySelectorAll('[data-section]').forEach((section) => {
      section.setAttribute('data-loaded', true);
    });
  });
}

// Set the GCM Diagram width on page load
document.querySelector('.gcmDiagram').setAttribute('width', `${document.querySelector('.gcmDiagram').parentElement.offsetWidth}px`);
// Set the CBRN Diagram width on page load
document.querySelector('.cbrnDiagram').setAttribute('width', `${document.querySelector('.cbrnDiagram').parentElement.offsetWidth}px`);

// *********************************************************************************** //
// * Social Sharing Buttons                                                          * //
// *********************************************************************************** //
const blogUrl = `https://mgrs-mapper.com${window.location.pathname}`;
const href = `https://twitter.com/intent/tweet/?text=${encodeURIComponent(document.title)}&url=${encodeURIComponent(blogUrl)}&via=MGRSMapper`;
const socialButtons = document.querySelectorAll('.container > a.socialLink');

socialButtons.forEach((btn) => {
  btn.addEventListener('click', (event) => {
    const destination = event.target.getAttribute('tooltip');
    switch (destination) {
      case 'Facebook':
        console.log('This is FB');
        window.open(`https://www.facebook.com/sharer/sharer.php?u=${blogUrl}`, 'sharer', 'width=626,height=436');
        break;
      case 'Twitter':
        console.log('You got twitter');
        window.open(href, 'Twitter', 'toolbar=no,location=0,status=no,menubar=no,scrollbars=yes,width=626,height=436,resizable=1');
        break;
      case 'Email':
        console.log('Thats an email');
        window.location.href = `mailto:?subject=${document.title} there&body=I found this link on MGRS-Mapper.com ${blogUrl}`;
        break;
      default:
        break;
    }
  });
});
